import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const uploadFormPhd = async (data) =>
  api.post(API_URL + "upload/formPhd", data);

export const uploadFormPostdoc = async (data) =>
  api.post(API_URL + "upload/formPostdoc", data);
